module.exports = __webpack_public_path__ + "static/media/SWSCRC1-16.b6a0bfab.mp3";